/**
 * AttachmentViewer — displays voice/photo attachments with presigned URLs.
 *
 * A13-N11.
 *
 * Props:
 *  - urls: [{ attachment_id, attachment_type, mime_type, download_url, duration_seconds }]
 */

import { useTranslation } from 'react-i18next';

export default function AttachmentViewer({ urls }) {
  const { t } = useTranslation();

  if (!urls || urls.length === 0) {
    return null;
  }

  const voices = urls.filter((u) => u.attachment_type === 'voice');
  const photos = urls.filter((u) => u.attachment_type === 'photo');

  return (
    <div className="space-y-3 mb-4" data-testid="attachment-viewer">
      {voices.length > 0 && (
        <div>
          <h3 className="text-xs font-semibold text-[var(--aif-text-muted)] uppercase tracking-wide mb-1">
            {t('brainDump.voiceRecording', 'Sprachaufnahme')}{voices.length > 1 ? 'n' : ''}
          </h3>
          {voices.map((v) => (
            <audio
              key={v.attachment_id}
              controls
              src={v.download_url}
              className="w-full"
              data-testid="voice-player"
            />
          ))}
        </div>
      )}

      {photos.length > 0 && (
        <div>
          <h3 className="text-xs font-semibold text-[var(--aif-text-muted)] uppercase tracking-wide mb-1">
            {t('brainDump.photos', 'Foto')}{photos.length > 1 ? 's' : ''}
          </h3>
          <div className="grid grid-cols-2 gap-2">
            {photos.map((p) => (
              <a
                key={p.attachment_id}
                href={p.download_url}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <img
                  src={p.download_url}
                  alt={t('brainDump.capturedPhoto', 'Captured photo')}
                  className="w-full h-32 object-cover rounded-lg border border-[var(--aif-border-default)]"
                  data-testid="photo-thumbnail"
                />
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
